import React from "react";
import { useDeleteUserMutation } from "../../Services/user/Users";
import { toast } from "react-toastify";

interface IProps {
  closeDeleteModal: any;
  userData: any;
  refetch: any;
}

const DeleteUserModal: React.FC<IProps> = ({
  closeDeleteModal,
  userData,
  refetch,
}) => {
  const [deleteUser] = useDeleteUserMutation(userData.id);

  const handleDelete = async () => {
  try {
    await deleteUser(userData.id).unwrap();

    toast.success("User deleted successfully!");
    closeDeleteModal();
    refetch();

  } catch (error) {
    console.error("Failed to delete user:", error);

    let errorMessage = "Failed to delete user. Please try again.";

    if (error?.data?.length > 0) {
      errorMessage = error.data[0]; // show first message from backend
    } else if (error?.data?.message) {
      errorMessage = error.data.message;
    }

    toast.error(errorMessage);
  }
};

  return (
    <div className="card-body">
      <p className="fs-5 fw-bold">
        Are you sure you want to delete the following user
        <p className="fs-6"> {userData.username}?</p>
      </p>

      <div className="d-flex justify-content-end mt-10">
        <button
          type="reset"
          className="btn btn-sm btn-white btn-active-light-primary me-2"
          onClick={() => closeDeleteModal()}
        >
          Cancel
        </button>

        <button
          type="submit"
          className="btn btn-sm btn-danger"
          onClick={handleDelete}
        >
          <span className="indicator-label">Delete</span>
        </button>
      </div>
    </div>
  );
};

export default DeleteUserModal;
